import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 8,
			fill: "#8E68F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3984 14.1016H30.5984C31.6984 14.1016 32.5984 15.0016 32.5984 16.1016V18.3016C32.5984 19.1016 32.0984 20.1016 31.5984 20.6016L27.2984 24.4016C26.6984 24.9016 26.2984 25.9016 26.2984 26.7016V31.0016C26.2984 31.6016 25.8984 32.4016 25.3984 32.7016L23.9984 33.6016C22.6984 34.4016 20.8984 33.5016 20.8984 31.9016V26.6016C20.8984 25.9016 20.4984 25.0016 20.0984 24.5016L16.2984 20.5016C15.7984 20.0016 15.3984 19.1016 15.3984 18.5016V16.2016C15.3984 15.0016 16.2984 14.1016 17.3984 14.1016Z",
			stroke: "white",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.93 14.1016L18 22.0016",
			stroke: "white",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFilterIcon;
